import React, { useEffect, useState } from 'react';

import Typography from '@mui/material/Typography';
import { isFunction } from 'lodash';

interface CountdownTimerProps {
  message: string;
  timeout: number; //* seconds
  onTimeout?: () => void;
}

function CountdownTimer(props: CountdownTimerProps) {
  const [countdown, setCountdown] = useState(props.timeout);
  const [message, setMessage] = useState(props.message);
  const [timerId, setTimerId] = useState(-1);

  useEffect(() => {
    if (timerId < 0) {
      const id = window.setInterval(() => {
        setCountdown((value) => {
          const newValue = value - 1;
          return newValue;
        });
      }, 1000);
      setTimerId(id);
    }
  }, []);

  useEffect(() => {
    setMessage(props.message.replace('{{time}}', `${countdown}`));
    if (countdown === 0) {
      window.clearInterval(timerId);
      if (isFunction(props.onTimeout)) {
        props.onTimeout();
      }
    }
  }, [countdown]);

  return <Typography variant="body1">{message}</Typography>;
}

export default CountdownTimer;
